import { useEffect, useState } from 'react';

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  withTooltip,
} from '@crossnokaye/ux-common';
import { DropdownInput } from '@crossnokaye/ux-common/ckds';

import { EVENT_DAYS } from './defrost-schedule.constant';

const DropdownInputWithTooltip = withTooltip(DropdownInput);

type DefrostScheduleEventDayDropdownProps = {
  disabled: boolean;
  error?: string;
  onChange: (values: string[]) => void;
  values: string[];
};

export const DefrostScheduleEventDayDropdown = ({
  disabled,
  error,
  onChange,
  values,
}: DefrostScheduleEventDayDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (disabled) setIsOpen(false);
  }, [disabled]);

  const handleOpenChange = (open: boolean) => {
    if (disabled && open) return;
    setIsOpen(open);
  };

  const handleChange = (checked: boolean, day: string) => {
    const newValues = checked ? [...(values ?? []), day] : (values?.filter((v) => v !== day) ?? []);
    onChange(newValues);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <DropdownInputWithTooltip
          className={
            error && 'border-ckds-input-border-error focus-visible:border-ckds-input-border-error'
          }
          contentClassName="text-ckds-base-critical"
          delayDuration={50}
          disabled={disabled}
          placeholder="Select Day(s)"
          tooltipContent={error ? error : undefined}
          triggered={isOpen}
          value={values?.join(', ') ?? ''}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-80 z-overlay" withPortal>
        {EVENT_DAYS.map((day) => (
          <DropdownMenuCheckboxItem
            checked={values?.includes(day.value)}
            key={day.value}
            onCheckedChange={(checked) => handleChange(checked, day.value)}
            onSelect={(event) => {
              // Radix closes the menu on item select by default; keep open for multi-select.
              event.preventDefault();
            }}
          >
            {day.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
